import { get } from '@ebay/presence-ui/lib/object-helpers';

export default class {
    onCreate(input) {
        this.state = {
            returnUrl: null,
            liveMock: null,
            isLiveMockForm: get(input, 'page.devFlags.isLiveMockForm', false),
            isLiveMockRender: get(input, 'page.devFlags.isLiveMockRender', false)
        };
        const mockStr = JSON.stringify(input.page);

        if (this.state.isLiveMockForm) {
            this.state.liveMock = encodeURIComponent(mockStr);
        } else if (this.state.isLiveMockRender) {
            this.state.liveMock = mockStr;
        }
    }
    onMount() {
        if (this.state.isLiveMockForm) {
            const anchor = document.createElement('a');
            anchor.href = window.location.href;
            if (anchor.search) {
                const tokens = anchor.search.replace(/^\?/, '').split('&');
                tokens.forEach(token => {
                    const pair = token.split('=');
                    if (pair[0] === 'returnurl') {
                        this.state.returnUrl = decodeURIComponent(pair[1]);
                        this.update();
                        this.el.submit();
                    }
                });
            }
        }
    }
}
